import React from 'react';
import Hero from './components/faculty-details/Hero';
import Main from './components/faculty-details/Main';

const FacultyDetails = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default FacultyDetails;